import { VideoChatService } from "../services/VideoChatService";
import { triggerEarningsPopup } from "../components/EarningsPopupManager";

/**
 * Utility functions for notifications
 */


/**
 * Check therapist earning by calling new API endpoint
 * @param meetingId - The meeting ID to check earnings for
 */
export const checkAndShowTherapistEarning = async (meetingId: string) => {
  if (!meetingId) {
    return;
  }

  try {
    const response = await VideoChatService.getTherapistEarningByMeeting(meetingId);
    
    if (response.success && response.data?.hasEarning && response.data?.is_need_to_show) {
      const earningData = response.data;
      
      // Show the beautiful earnings popup with sound
      setTimeout(() => {
        triggerEarningsPopup(earningData.amount);
      }, 1000); // Delay to show after the main success message
      
      // Mark as shown to prevent duplicate notifications
      try {
        await VideoChatService.markEarningNotificationShown(earningData._id);
        console.log('Earning notification marked as shown for transaction:', earningData._id);
      } catch (markError) {
        console.warn('Failed to mark earning as shown:', markError);
      }
      
      console.log('Therapist earning notification shown:', earningData);
    }
  } catch (error) {
    console.warn('Unable to check therapist earning:', error);
  }
};

